import { WidgetConsentSubmitStatus } from 'widget/entities/config';
import FormFieldModel from 'widget/models/FormFieldModel';

export type ConsentFieldModelParams = {
  required: boolean;
  enabled: boolean;
  status?: WidgetConsentSubmitStatus;
};

export default class ConsentFieldModel {
  private readonly required: boolean;
  readonly enabled: FormFieldModel<boolean>;
  readonly status: FormFieldModel<WidgetConsentSubmitStatus>;

  constructor(params: ConsentFieldModelParams) {
    this.required = params.required;
    this.enabled = new FormFieldModel(params.enabled);
    this.status = new FormFieldModel(
      params.status ?? WidgetConsentSubmitStatus.pending
    );
  }

  get isRequired(): boolean {
    return this.required;
  }

  reset(): void {
    this.enabled.reset();
    this.status.reset();
  }
}
